import Backbone from 'backbone'
import _ from 'lodash'
import template from './pages-edit.hbs'
import DisplayHeader from 'scoreboard/components/display-header'
import tabs from 'scoreboard/components/view-edit-tabs.hbs'
import EditButtons from 'scoreboard/components/edit/edit-buttons'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import formHelper from 'scoreboard/components/form-helper'
import conductor from 'scoreboard/components/conductor'
import AddFormWidgetMenu from './add-form-widget-menu'
import Tooltip from 'scoreboard/components/tooltip'
import constants from 'scoreboard/components/constants'
import WidgetsView from '../widgets/widgets-view'
import i18n from 'scoreboard/components/i18n'
import addFirstHint from 'scoreboard/components/add-first-hint.hbs'
import DraggableList from 'draggable-list'
import reorderAfterDrag from 'scoreboard/components/reorder-after-drag'
import datasetLabel from './dataset-label.hbs'
import duplicateButton from './duplicate-button.hbs'
import paste from 'scoreboard/components/paste/paste'
import DisplayActions from 'scoreboard/forms/edit/display-actions-editor'
import appDisplay from 'scoreboard/components/app-display'
import FormWidgetType from 'scoreboard/forms/model/form-widget-type'
const { RECORD_LIST, FIELD, CHECKBOXES } = FormWidgetType
import inputLengthValidatorFactory from 'scoreboard/components/validators/input-length-validator-factory'
import { triggerAddOrEdit } from 'scoreboard/components/domain-object-events'
import formType from '../model/form-type'

const PagesEdit = Backbone.View.extend({

	tagName: 'form',

	className: 'table-hack display-layout forms-edit-view',

	events: {
		'click .cancel': 'onClickCancel',
		'click .add-form-widget': 'onClickAddFormWidget',
		'click .duplicate': 'onClickDuplicate',
		'click .display-actions': 'onClickDisplayActions'
	},

	/** @type {Form} */
	model: null,

	initialize: function(options = {}) {
		this.options = options
		this.template = template

		this.displayActionTitle = i18n.get('forms.page.pageDisplayActions')
		this.displayActionBannerMsg = i18n.get(
			'forms.actions.pageDisplayActionsBanner',
			i18n.get('forms.actions.actionsBannerPart2'))
		this.displayActionEmptyMsg = i18n.get('forms.actions.emptyPageDisplay')

		// Overridden by DialogsEditWidgetsForm to hide the dashboard and record
		// list menus
		this.showDashboardAndRecordListMenus = true

		// #35434 do this first to make sure we always have a populated widgets
		// property, even if we press cancel
		if (!this.model.get('widgets')) {
			this.model.set('widgets', [])
		}

		if (this.model.isNew()) {
			this.model.set('label', i18n.get('forms.newPage'))
		}

		this.originalModel = this.model.cloneDeep()
	},

	render: function() {
		this.createHeader()

		this.$el.empty().append(this.header.el, this.template())
		this.header.render()

		this.renderDatasetLabel()

		formHelper.writeToDom(this.model, this.el)

		this.renderEditButtons()

		// #55530 - validate name length
		let labelLengthValidator = inputLengthValidatorFactory({
			high: 2000
		})
		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validators: [requiredValidator, labelLengthValidator]
		}).render()

		let hint = addFirstHint({ hint: i18n.get('dashboards.addFirstWidget') })
		this.$('.widgets-view-container').append(hint)

		// before this.renderDraggableWidgets (which is called by this.renderWidgets)
		this.setupFormView()

		this.renderWidgets()

		this.toggleAddWidgetHint()

		// #36061 make sure 'Add Widget' button works for new pages
		this.delegateEvents()

		this.resize()
		this.on('resize', () => this.resize())

		// Pre-select the label field so users can start typing right away
		this.$('[name=label]').select()

		return this
	},

	renderDatasetLabel() {
		const dataset = getDialogDatasetOrDataset(this.model)
		this.$('.dataset-label-container').append(datasetLabel({
			label: dataset.get('label'),
			href: `datasets/${dataset.get('id')}`
		}))
	},

	resize() {
		// Upon resize, set the menu space which stores the amount of space available to the add form
		// menu when it's deployed.
		let widgetsViewContainer = this.$('.widgets-view-container')
		this.menuSpace = {
			width: widgetsViewContainer.width(),
			height: widgetsViewContainer.height()
		}
	},

	setupFormView: function() {
		const cancelButtonEl = this.$('.cancel').first()
		const primaryButtonEl = this.$('.save')
		if (this.formView) {
			// if we are re-rendering, then we just need to update the buttons
			// and restart the view, formView.start() will set up the buttons
			this.formView.start({
				primaryButtonEl,
				cancelButtonEl
			})
			return
		}
		this.formView = new FormView({
			toggleCancel: true,
			el: this.el,
			submit: this.submit.bind(this),
			test: this.test.bind(this),
			// Allow clean submission since we populate a placeholder label
			allowCleanSubmission: () => this.model.isNew(),
			// #34591 specify the correct buttons
			primaryButtonEl,
			cancelButtonEl,
			guardOptions: {
				// #56700 the guard checks whether a save is okay by whether the
				// primary button is disabled. There may be a primary button on
				// record lists on the form, so this selection needs to filter
				// those out
				primaryButtonSelector: '.panel.edit-form .button-primary'
			}
		})
		this.formView.start({
			isNew: this.model.isNew()
		})
	},

	createHeader: function() {
		this.header = new DisplayHeader({
			heading: this.model.get('label') || i18n.get('common.create2', 'forms.newPage'),
			model: this.model,
			subsection: 'edit',
			tabs: tabs({
				id: this.model.id || this.model.get('parentId'),
				section: 'forms',
				overviewTabCode: 'common.view',
				hideInfo: true,
				hideAlerts: true
			})
		})
	},

	renderDraggableWidgets: function() {
		let list = this.$('.widgets-view')
		if (list.find('.form-widget').length > 1) {
			_.invoke(this.draggableWidgets, 'remove')
			this.draggableWidgets = new DraggableList(list[0], {
				scrollEl: this.$('.widgets-view-container')[0]
			})
			this.draggableWidgets.on('move', (el, newIndex, prevIndex) => {
				reorderAfterDrag(this.model.get('widgets'), newIndex, prevIndex)
				reorderAfterDrag(this.widgetsView.widgetViews, newIndex, prevIndex)
				this.formView.change()
			})
		}
	},

	renderEditButtons: function() {
		// set up buttons
		this.editButtons = new EditButtons({
			model: this.model,
			pasteAllowed: false
		})

		this.$('.edit-buttons').replaceWith(this.editButtons.el)
		this.editButtons.render()

		// hide the move and copy buttons
		this.$('.move-copy').remove()

		// #46378 add the 'duplicate' button
		this.$('.edit-buttons')
			.prepend(duplicateButton())
		// #51642 don't display the 'duplicate' button for unsaved pages
		this.$('.duplicate').toggleClass('is-not-displayed', this.model.isNew())
	},

	renderWidgets: function() {
		let widgetViewModel = this.model
		// Ensure dialog specific datasets are used when applicable for widgets
		widgetViewModel.dataset = getDialogDatasetOrDataset(this.model)

		if (this.widgetsView) {
			// to support cancel button
			this.widgetsView.model = widgetViewModel
		} else {
			this.widgetsView = new WidgetsView({
				model: widgetViewModel,
				allowInput: false
			})
			this.widgetsView.on('edit delete', () => {
				if (_.isNil(this.test())) this.formView.clearErrors()
				this.formView.change()
				this.toggleAddWidgetHint()
				this.renderDraggableWidgets()
			})
		}
		this.$('.widgets-view-container').append(this.widgetsView.el)
		this.widgetsView.render()
		this.toggleAddWidgetHint()
		this.renderDraggableWidgets()
	},

	toggleAddWidgetHint: function() {
		let hasWidgets = !_.isEmpty(this.model.get('widgets'))
		this.$('.add-first-hint').toggleClass('is-not-displayed', hasWidgets)
	},

	onClickDisplayActions: function() {
		const dialog = new DisplayActions({
			model: this.model,
			title: this.displayActionTitle,
			bannerMsg: this.displayActionBannerMsg,
			emptyMessage: this.displayActionEmptyMsg
		})
		dialog.on('done', (statements) => {
			this.formView.change()
			this.model.set({ statements })
		})
		appDisplay.dialog(dialog)
	},

	onClickAddFormWidget: function () {
		let addButton = this.$('.add-form-widget')

		_.invoke(this.menu, 'remove')
		this.menu = new AddFormWidgetMenu({
			model: this.model,
			addButton,
			formEl: this.$('.widgets-view-container'),
			menuSpace: this.menuSpace,
			showDashboardMenu: this.showDashboardAndRecordListMenus,
			showRecordListMenu: this.showDashboardAndRecordListMenus
		})
		this.menu.on('add-widget', widget => {
			this.model.get('widgets').push(widget)
			this.renderWidgets()
			this.formView.change()
			if (widget.valueLabelFieldId && this.addFormWidgetTooltip) {
				// #46722 if we selected a linked dataset field, then we just
				// want to close the menu as the user shouldn't be able
				// to select any more fields from the linked dataset.
				this.addFormWidgetTooltip.remove()
			}
		})

		this.addFormWidgetTooltip = new Tooltip({
			attachTo: addButton,
			content: this.menu,
			placement: 'below',
			arrow: 'left',
			// This aligns the left edge of the tooltip with the left edge of the
			// Add Widget button
			adjustment: -(addButton.width()/2) + constants.TOOLTIP_ARROW_WIDTH,
			extraClass: 'add-form-widget-tooltip has-bootslide-menu'
		}).render()
	},

	onClickCancel: function() {
		if (this.model.isNew()) {
			conductor.edit()
		} else {
			this.model = this.originalModel.cloneDeep()
			this.render()
		}
		this.addFormWidgetTooltip?.remove()
	},

	/**
	 * 	Duplicate a page within the same form #46378
	 */
	onClickDuplicate: function() {
		let options = {
			mode: 'copy',
			section: 'forms',
			id: this.model.id,
			parentId: _.get(this.model.attributes, 'rootFormId'),
			orgId: _.get(this.model.attributes, 'organizationId')
		}
		paste(options, (ids) => {
			Backbone.trigger('copy:domain-object', options, ids)
		})
	},

	test: function() {
		// #51594 if it is an invalid configuration, show an error message
		let widgets = _.map(this.$('.form-widget'), el =>
			this.$(el).data('widget'))
		// #56812
		// Check if there are widgets with the same field to avoid a saving conflict
		return testDuplicateEditableFields(this.model, widgets) ??
			testRecordListWidgetCompatibility(widgets)
	},

	submit: function() {
		let action = this.model.isNew() ? 'add' : 'edit'

		let widgets = _.map(this.$('.form-widget'), el =>
			this.$(el).data('widget'))

		let data = _.extend({}, this.model.attributes,
			formHelper.readFromDom(this.el), { widgets })

		return this.model.save(cleanSubmitData(data), {
			url: _.result(this.model, 'url'),
			patch: true,
			success: function(model, response) {
				this.trigger('save', model)
				triggerAddOrEdit(action, model)
				this.originalModel = this.model.cloneDeep()
				this.formView.start({ isNew: false })
				this.render({ instadone: true })
			}.bind(this),
			error: (model, xhr) => this.formView.error(xhr)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.header, this.labelField, this.editButtons,
			this.widgetsView, this.draggableWidgets, this.menu], 'remove')
	}

})

/**
 * To avoid a save conflict, check if there are widgets with the same field.
 * Currently, this is only possible between checkbox and field widgets.
 * Returns an error message if a duplicate is detected.
 * @param model - the form model used to retrieve field labels
 * @param widgets - the list of form widgets being checked
 * @returns {string|null} - the error message if there are duplicate fields
 */
function testDuplicateEditableFields(model, widgets) {
	const widgetFieldIds = new Set()
	let duplicateFieldId
	let message = null
	widgets.forEach(w => {
		let fieldId = parseFloat(w?.fieldId)
		if (w?.type === FIELD) {
			if (widgetFieldIds.has(fieldId)) {
				duplicateFieldId = fieldId
			}
			widgetFieldIds.add(fieldId)
		} else if (w?.type === CHECKBOXES) {
			w?.childWidgets?.forEach(childWidget => {
				// Child widgets have their fieldId nested under the parent
				// widget, so we need to extract it
				fieldId = parseFloat(childWidget?.fieldId)
				if (widgetFieldIds.has(fieldId)) {
					duplicateFieldId = fieldId
				}
				widgetFieldIds.add(fieldId)
			})
		}
	})

	if (duplicateFieldId) {
		message = i18n.get(
			'forms.actions.invalidSaveConfiguration.duplicateFields',
			model?.dataset?.combinedFieldsById[duplicateFieldId]?.label
		)
	}
	return message
}

/**
 * Checks if a record list widget is being saved with either a checkbox or
 * field widget. If so, returns an error message.
 * @param widgets - the list of form widgets being checked
 * @returns {String} - the error message if the widgets are incompatible
 */
function testRecordListWidgetCompatibility(widgets) {
	const hasRecordListWidget =
		_.some(widgets, w => w.type == RECORD_LIST)
	const hasFieldWidget =
		_.some(widgets, w => w.type == FIELD)
	const hasCheckboxesWidget =
		_.some(widgets, w => w.type == CHECKBOXES)

	let code = null
	if (hasRecordListWidget && hasCheckboxesWidget) {
		code = 'forms.widgets.widget.checkboxes'
	}
	if (hasRecordListWidget && hasFieldWidget) {
		code = 'forms.widgets.widget.field'
	}

	return _.isNil(code) ? code :
		i18n.get(
			'forms.actions.invalidSaveConfiguration',
			_.lowerCase(i18n.get(code))
		)
}

/**
 * Removes items from the submit data that should not be sent to the server.
 */
function cleanSubmitData (data) {
	// Start by cloning the data, since we're going to be altering items
	// that may have come from a backbone model
	let cleaned = _.cloneDeep(
		// #57566 do not include the dataset in the save request
		// And omit before cloning, because clone a big linked dataset can
		// be expensive
		_.omit(data, 'dataset'))

	cleanWidgets(cleaned.widgets)
	cleanWidgets(cleaned.allWidgets)

	return cleaned
}

function cleanWidgets (widgets) {
	widgets?.forEach(w => {
		if (w.dashboard) {
			// Safe to mutate, because we cloned this already
			delete w.dashboard.data

			if (w.dashboard.dirty) {
				// dirty flag is only needed on the client
				delete w.dashboard.dirty
			} else {
				// #58456 if the dashboard hasn't been changed, don't send it
				// to the server; adjustments would need to be made before
				// submitting, and it's pointless anyway if there weren't any
				// changes
				delete w.dashboard
			}
		}
		delete w.dashboardData
	})
}

/**
 * Returns the dialog dataset if the form is a dialog, otherwise returns the
 * form's dataset.
 * @param formModel {Form} - the form model currently in use
 * @returns {Dataset} - the dataset to be used for the form
 */
function getDialogDatasetOrDataset(formModel) {
	if (formModel?.get?.('type') === formType.DIALOG && formModel.dialogDataset) {
		return formModel.dialogDataset
	} else {
		return formModel.dataset
	}
}

export default PagesEdit
export { testRecordListWidgetCompatibility, testDuplicateEditableFields,
	cleanSubmitData, getDialogDatasetOrDataset }

PagesEdit.__filename__ = 'forms/edit/pages-edit.js'
